<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="49.822" height="12.787" viewBox="0 0 49.822 12.787">
		<g id="Group_36430" data-name="Group 36430" transform="translate(0.75 0.75)">
			<path
				id="Path_21163"
				data-name="Path 21163"
				d="M8.951,44.76V0H0"
				transform="translate(46.249 0.024) rotate(90)"
				fill="none"
				stroke="#dfe4ef"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="1.5"
			/>
			<path
				id="Path_21294"
				data-name="Path 21294"
				d="M1.951,4,0,2,1.951,0"
				transform="translate(0 6.977)"
				fill="none"
				stroke="#dfe4ef"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="1.5"
			/>
			<path
				id="Path_21295"
				data-name="Path 21295"
				d="M1.951,4,0,2,1.951,0"
				transform="translate(48.011) rotate(90)"
				fill="none"
				stroke="#dfe4ef"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="1.5"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'SubFolderSvg',
};
</script>

<style scoped lang="scss"></style>
